export enum RESTRICTIONS_TYPE {
  ALL_ACCESS,
  PPP_ACCESS_BLOCKED,
  PREP_ACCESS_ONLY,
}
